export default "__VITE_ASSET__CYPNkXVC__"